import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

const EMPTY = { title: "", subtitle: "", story: "", highlights: [] };

export default function AdminRacingStory() {
  const [form, setForm] = useState(EMPTY);
  const [newH, setNewH] = useState("");

  useEffect(() => {
    api.get("/racing-story").then((r) => {
      const d = r.data || {};
      setForm({
        title: d.title || "",
        subtitle: d.subtitle || "",
        story: d.story || "",
        highlights: d.highlights || [],
      });
    });
  }, []);

  const save = async () => {
    try {
      await api.put("/admin/racing-story", form);
      toast.success("Storia aggiornata");
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "Errore");
    }
  };

  const addH = () => {
    if (!newH.trim()) return;
    setForm((f) => ({ ...f, highlights: [...f.highlights, newH.trim()] }));
    setNewH("");
  };
  const removeH = (i) => setForm((f) => ({ ...f, highlights: f.highlights.filter((_, j) => j !== i) }));

  return (
    <div className="max-w-3xl">
      <span className="label-eyebrow text-gray-500">Racing Team</span>
      <h1 className="font-display uppercase text-4xl mt-1">Storia</h1>

      <div className="card-flat p-6 md:p-8 mt-8 space-y-5">
        <div>
          <label className="label-eyebrow text-gray-500 block mb-2">Titolo</label>
          <input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3" data-testid="story-title" />
        </div>
        <div>
          <label className="label-eyebrow text-gray-500 block mb-2">Sottotitolo</label>
          <input value={form.subtitle} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3" data-testid="story-subtitle" />
        </div>
        <div>
          <label className="label-eyebrow text-gray-500 block mb-2">Storia</label>
          <textarea rows={10} value={form.story} onChange={(e) => setForm({ ...form, story: e.target.value })} className="w-full border border-gray-300 focus:border-gray-900 outline-none px-3 py-3" data-testid="story-body" />
        </div>
        <div>
          <label className="label-eyebrow text-gray-500 block mb-2">Highlights</label>
          <ul className="space-y-2 mb-3">
            {form.highlights.map((h, i) => (
              <li key={i} className="flex items-center gap-2 border border-gray-200 px-3 py-2">
                <span className="text-[color:var(--nsa-orange)]">▸</span>
                <span className="flex-1">{h}</span>
                <button onClick={() => removeH(i)} className="text-gray-500 hover:text-red-600"><X size={14} /></button>
              </li>
            ))}
          </ul>
          <div className="flex gap-2">
            <input value={newH} onChange={(e) => setNewH(e.target.value)} placeholder="Aggiungi highlight" className="flex-1 border border-gray-300 focus:border-gray-900 outline-none px-3 py-2" data-testid="story-highlight-input" />
            <button onClick={addH} className="border border-gray-300 px-4 label-eyebrow inline-flex items-center gap-1" data-testid="story-highlight-add"><Plus size={14} /> Aggiungi</button>
          </div>
        </div>
        <button onClick={save} className="btn-orange label-eyebrow px-6 py-3" data-testid="story-save">Salva storia</button>
      </div>
    </div>
  );
}
